import { render, staticRenderFns } from "./access-component.vue?vue&type=template&id=c695cbba"
import script from "./access-component.vue?vue&type=script&lang=ts"
export * from "./access-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports